import React from 'react';
import { useHistory } from 'react-router';
import AssignmentCreate from '../components/Assignment/AssignmentCreate';
import { getQueryParams } from '../helpers/url';

const AssignmentCreatePage = () => {
  const history = useHistory();
  const {
    classId,
    mloId,
    trimesterId,
    instructionalPlanId,
    teachingPeriodId,
  } = getQueryParams(history);

  const onGoBack = () => {
    history.goBack();
  };

  return (
    <AssignmentCreate
      classId={classId}
      mloId={mloId}
      trimesterId={trimesterId}
      teachingPeriodId={teachingPeriodId}
      instructionalPlanId={instructionalPlanId}
      onGoBack={onGoBack}
      history={history}
    />
  );
};

export default AssignmentCreatePage;
